import { registerPropertyManagerSection } from '@/core';
import ShellPropertySection from '@/components/editor/property-manager/shell/ShellPropertySection.vue';

/**
 * 注册抽壳属性面板。
 *
 * 设计说明：
 * 1. 与圆角/倒角同一注册契约：isApplicable 控制面板可见性，actions 控制确认/取消；
 * 2. 抽壳面板只负责展示与参数修改，提交/取消统一回调 context 注入的动作。
 */
registerPropertyManagerSection({
    id: 'shell-feature',
    title: '抽壳',
    order: 34,
    component: ShellPropertySection,
    actions: {
        confirm: true,
        cancel: true,
    },
    resolveConfirmDisabled: (context) => context.shellCanSubmit === false,
    isApplicable: (context) => {
        if (context.activeCommand === 'shell') {
            return true;
        }
        return context.shellActive === true;
    },
    onConfirm: (context) => {
        void context.submitShell?.();
    },
    onCancel: (context) => {
        context.cancelShell?.();
    },
});
